<template>
  <div style="height: calc(100% - 80px)">
    <el-button
      type="primary"
      @click="roomList"
      style="margin-bottom: 0.5rem"
      size="small"
      >房間概覽</el-button
    >
    <el-card class="box-card" style="margin-bottom: 5px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="Last Name:">
              <el-input v-model="form.lastname" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="First/Middle:">
              <el-input v-model="form.firstname" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Salutation:">
              <el-input v-model="form.salutation" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Alt. Name:">
              <el-input v-model="form.altName" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Company:">
              <el-input v-model="form.company" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Job Title:">
              <el-input v-model="form.job" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Tel:">
              <el-input v-model="form.tel" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Remark:">
              <el-input v-model="form.remark" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card" style="margin-bottom: 10px">
      <span style="font-size: 14px">Room Type:</span>
      <el-select v-model="roomType" size="small">
        <el-option
          v-for="i in opts"
          :key="i.value"
          :value="JSON.stringify(i)"
          :label="i.label"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addRoom"
        size="small"
        style="margin-left: 0.5rem"
      ></el-button>
      <div class="room-list">
        <el-row
          v-for="(i, index) in form.rooms"
          :key="i.id"
          style="border: solid 1px #efefef; height: auto; font-size: 14px"
        >
          <el-col style="background-color: #67c23a; padding: 10px" :span="22">
            <el-row style="line-height: 30px">
              <el-col :span="4">
                <el-row>
                  <span
                    tyle="display: inline-block;text-align: right; width: 80px;"
                  >
                    Room Type:
                  </span>
                  {{ i.roomTypeDisplay }}
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 70px;
                    "
                  >
                    Amount:
                  </span>
                  <el-input-number
                    size="small"
                    v-model="i.amount"
                    controls-position="right"
                    :min="0"
                    :max="maxData[i.id]"
                    @change="computeMaxQuota(i)"
                  ></el-input-number>
                </el-row>
              </el-col>
              <el-col :span="13">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 120px;
                    "
                  >
                    Arrival/Departure:
                  </span>
                  <el-date-picker
                    v-model="i.date"
                    size="small"
                    type="daterange"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="開始日期"
                    end-placeholder="結束日期"
                    @change="computeMaxQuota(i)"
                  >
                  </el-date-picker>
                </el-row>
              </el-col>
              <el-col :span="4">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 80px;
                    "
                  >
                    Night:
                  </span>
                  {{ (i.night = getDaysBetween(i.date[0], i.date[1])) }}
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 70px;
                    "
                  >
                    Price:
                  </span>
                  <el-input-number
                    size="small"
                    v-model="i.rate"
                    controls-position="right"
                    :min="1"
                  ></el-input-number>
                </el-row>
              </el-col>
              <el-col :span="13">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 120px;
                    "
                  >
                    Rate:
                  </span>
                  {{ moneyStr(i.rate * i.night * i.amount) }}
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2" :class="commonClass">
            <span
              @click="delRoom(index)"
              style="display: block; width: 100%; height: 100%"
            >
              删除
            </span>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-col :span="24" style="font-size: 14px">
      Total Rate: {{ moneyStr(totalRate) }}
    </el-col>
    <el-button
      type="primary"
      @click="submit"
      :loading="loading"
      style="margin-top: 20px"
      size="small"
    >
      提交
    </el-button>
    <rooms-modal :typeList2="opts" ref="roomsModal"></rooms-modal>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { getRoomType, submit, getRoomQuota } from "@/api/guest/appointment";
import RoomsModal from "./modules/RoomsModal";
export default {
  components: {
    RoomsModal
  },
  data() {
    return {
      maxData: [],
      loading: false,
      id: 1,
      form: {
        lastname: "",
        firstname: "",
        salutation: "",
        altName: "",
        company: "",
        job: "",
        tel: "",
        rooms: [],
        remark: ""
      },
      opts: [],
      roomType: "",
      hasMessage: false,
      messageClass: "message-class",
      commonClass: "delbtn-class"
    };
  },
  created() {
    getRoomType().then(res => {
      this.opts = res.data.map(_ => {
        return {
          label: _.Text,
          value: _.Code,
          rate: _.Rate
        };
      });
    });
  },
  computed: {
    totalRate() {
      return this.form.rooms.reduce((total, item) => {
        return total + item.amount * item.rate * item.night;
      }, 0);
    }
  },
  methods: {
    submit() {
      this.loading = true;
      submit({
        LastName: this.form.lastname,
        FirstName: this.form.firstname,
        Salutation: this.form.salutation,
        AltName: this.form.altName,
        Company: this.form.company,
        JobTitle: this.form.job,
        Tel: this.form.tel,
        Remark: this.form.remark,
        TotalRate: this.moneyStr(this.totalRate),
        BookingRoomGroup: this.form.rooms.map(_ => {
          return {
            RoomType: _.roomTypeCode,
            Amount: _.amount,
            ArrivalDate: _.date[0],
            DepartureDate: _.date[1],
            Rate: _.rate
          };
        })
      })
        .then(() => {
          this.loading = false;
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success"
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    roomList() {
      this.$refs.roomsModal.visit();
    },
    addRoom() {
      if (!this.roomType) return;
      const obj = JSON.parse(this.roomType);
      this.$set(this.maxData, this.id, 0);
      this.form.rooms.push({
        id: this.id++,
        roomTypeCode: obj.value,
        roomTypeDisplay: obj.label,
        amount: 0,
        date: [],
        night: 0,
        rate: obj.rate,
        message: ""
      });
    },
    delRoom(index) {
      this.form.rooms.splice(index, 1);
    },
    getDaysBetween(dateString1, dateString2) {
      if (!dateString1 || !dateString2) return 0;
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (24 * 60 * 60 * 1000);
      return days;
    },
    moneyStr(num) {
      const arr = num.toString().split(".");
      arr[1] = arr[1] || "00";
      return arr[0].toLocaleString() + "." + (arr[1] + "00").slice(0, 2);
    },
    getData(selectRow) {
      return new Promise(resolve => {
        getRoomQuota({
          RoomType: selectRow.roomTypeCode,
          ArrivalDate: selectRow.date[0] || "",
          DepartureDate: selectRow.date[1] || "",
          ExpectAmount: selectRow.amount,
          BookingRoomGroup: this.form.rooms.map(_ => {
            return {
              RoomType: _.roomTypeCode,
              Amount: _.amount,
              ArrivalDate: _.date[0],
              DepartureDate: _.date[1],
              Rate: _.rate
            };
          })
        }).then(res => {
          if (selectRow) {
            selectRow.message = res.data.Message;
          }
          if (res.data.IsPass === undefined) {
            resolve(res.data.Quota);
          } else if (res.data.IsPass === false) {
            Message({
              message: res.data.Message || "Error",
              type: "error",
              duration: 5 * 1000
            });
            selectRow.amount = selectRow.amount - 1;
          }
        });
      });
    },
    async computeMaxQuota(selectRow) {
      if (selectRow.date.length === 0) {
        return;
      }
      const data = await this.getData(selectRow);
      this.$set(this.maxData, selectRow.id, Number(data));
    }
  }
};
</script>
<style lang="scss" scoped>
.room-list {
  height: calc(100% - 140px);
  margin-top: 20px;
  overflow: auto;
}
</style>
<style lang="scss">
.el-card__body {
  height: 100%;
}
.el-form-item {
  margin-bottom: 5px;
}
.message-class {
  background-color: #f56c6c;
  text-align: center;
  color: white;
  height: 100%;
  line-height: 99px;
  cursor: pointer;
}
.delbtn-class {
  background-color: #f56c6c;
  text-align: center;
  color: white;
  height: 100%;
  line-height: 84px;
  cursor: pointer;
}
.message-span {
  word-break: normal;
  width: auto;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
